import React from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { selectEntityNameMap } from 'store/loanApplications/selectors';
import { selectOtherUsersOnEntity } from 'store/presence/selectors';

import PresenceDot from './PresenceDot';

const PresenceEntityDot = ({ entityId, variant = 'inline' }) => {
  const otherUsers = useSelector(selectOtherUsersOnEntity(entityId));

  const entityNameMap = useSelector(selectEntityNameMap);

  return <PresenceDot entityNameMap={entityNameMap} users={otherUsers} variant={variant} />;
};

PresenceEntityDot.propTypes = {
  entityId: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['absolute', 'inline']),
};

export default PresenceEntityDot;
